if (!customElements.get('ppa-mobile-cart-bar')) {
  customElements.define('ppa-mobile-cart-bar', class extends HTMLElement {
    connectedCallback() {
      this.footer = document.getElementById('main-cart-footer');
      this.checkout = document.getElementById('checkout');
      this.total = this.querySelector('[data-mobile-cart-total]');
      this.media = window.matchMedia('(max-width: 749px)');
      this.checkoutVisible = false;
      this.sync = () => {
        const source = this.footer?.querySelector('.totals__total-value');
        const empty = !source || this.footer.classList.contains('is-empty');
        if (source && this.total.textContent !== source.textContent) this.total.textContent = source.textContent;
        this.hidden = empty || !this.media.matches || this.checkoutVisible;
        this.querySelector('button').disabled = empty;
      };
      this.observer = new MutationObserver(this.sync);
      if (this.footer) this.observer.observe(this.footer, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      this.intersection = new IntersectionObserver((entries) => {
        this.checkoutVisible = entries.some((entry) => entry.isIntersecting);
        this.sync();
      });
      if (this.checkout) this.intersection.observe(this.checkout);
      this.media.addEventListener('change', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.media?.removeEventListener('change', this.sync);
    }
  });
}
